import { type SelectOption } from '../../../../../components';
import { PAGE_TEXT } from '../lang';
import { MODE_OF_EMPLOYMENT, FIELD_OF_EMPLOYMENT } from '../constants';

// The employment mode options: full time, part time
const employmentModeText =
  PAGE_TEXT.OTHER_INFORMATION.EMPLOYMENT.MODE_OF_EMPLOYMENT_OPTIONS;

const employmentFieldText =
  PAGE_TEXT.OTHER_INFORMATION.EMPLOYMENT.FIELD_OF_EMPLOYMENT_OPTIONS;

const employmentModeKeys: string[] = Object.keys(employmentModeText);
const employmentFieldKeys: string[] = Object.keys(employmentFieldText);

export const employmentModeOptions: SelectOption[] = Object.values(
  employmentModeText,
).map((label: string, index: number) => ({
  value:
    MODE_OF_EMPLOYMENT[
      employmentModeKeys[index] as keyof typeof MODE_OF_EMPLOYMENT
    ],
  label,
}));

export const employmentFieldOptions: SelectOption[] = Object.values(
  employmentFieldText,
).map((label: string, index: number) => ({
  value:
    FIELD_OF_EMPLOYMENT[
      employmentFieldKeys[index] as keyof typeof FIELD_OF_EMPLOYMENT
    ],
  label,
}));
